import { ref } from 'vue';
import { useSubscription } from '@vue/apollo-composable';
import gql from 'graphql-tag';

const deviceConnectivity = ref(null);
let initialized = false;

export default function useSharedDeviceConnectivity() {
  // Ensure we only subscribe once
  if (!initialized) {
    initialized = true;

    const { onResult } = useSubscription(gql`
      subscription deviceConnectivity {
        deviceConnectivity {
          device
        }
      }
    `);

    onResult(({ data }) => {
      if (data?.deviceConnectivity) {
        deviceConnectivity.value = data.deviceConnectivity;
      }
    });
  }

  return {
    deviceConnectivity,
  };
}
